/**
 * Shared critical-key i18n policy (Item 16).
 * Used by apps/web loadLocale and build-time tests — keep in sync.
 */

/** @param {Record<string, string>} table */
export function stripMetaKeys(table) {
  /** @type {Record<string, string>} */
  const out = {};
  for (const [key, value] of Object.entries(table)) {
    if (key.startsWith("_quietvia.")) continue;
    out[key] = value;
  }
  return out;
}

/** @param {unknown} value */
export function isMeaningfulTranslation(value) {
  if (value === undefined || value === null) return false;
  return String(value).trim() !== "";
}

/**
 * @param {Record<string, string>} table
 * @param {string} key
 * @param {Set<string>} criticalKeySet
 * @param {Record<string, string>} englishTable
 */
export function translateKey(table, key, criticalKeySet, englishTable) {
  const value = table[key];
  if (isMeaningfulTranslation(value)) {
    return value;
  }
  if (criticalKeySet.has(key)) {
    return key;
  }
  return englishTable[key] ?? key;
}

/**
 * @param {Record<string, string>} localeTable
 * @param {Set<string>} enKeySet
 */
export function findUnexpectedLocaleKeys(localeTable, enKeySet) {
  /** @type {string[]} */
  const unexpected = [];
  for (const key of Object.keys(localeTable)) {
    if (key.startsWith("_quietvia.")) continue;
    if (!enKeySet.has(key)) unexpected.push(key);
  }
  return unexpected;
}
